import { render, staticRenderFns } from "./DuplicateStep3Finish.vue?vue&type=template&id=23a01aba&scoped=true&"
import script from "./DuplicateStep3Finish.vue?vue&type=script&lang=js&"
export * from "./DuplicateStep3Finish.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateStep3Finish.vue?vue&type=style&index=0&id=23a01aba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a01aba",
  null
  
)

export default component.exports